import VForm from '@/vuetify_custom/v-form'
import { VBtn, VCard, VCardTitle, VCardText } from 'vuetify/lib'
import VTable from '@/vuetify_custom/v-table/v3'
import VPopDel from './v-pop-del'
import Select from '@/vuetify_custom/v-form/components/Select_v1.js'
import NumberField from '@/vuetify_custom/v-form/components/Number_Field.js'

import { commonValidateRule, createContractInvoiceParams, isIllegalityValue } from '../utils'
import { common_mixins } from './EditMixIns.jsx'

import styles from './index.module.less'
const commonValidateRuleGo = commonValidateRule('必选')
export default {
    mixins:[common_mixins],
    computed: {
        table_fields() {
            const _this = this
            return [
                {
                    text: '发票类型',
                    key:'invoice_type',
                  
                    align: 'center',
                    value: 'invoice_type',
                    width: 300,
                    render:(_, target) => {
                        return <Select
                        required
                        v-model={target}
                        field = {{
                                key: 'invoice_type',
                             
                                items: [
                                    {
                                        title: '增值税普通发票',
                                        key: 'normal',
                                    },
                                    {
                                        title: '增值税专用发票',
                                        key: 'special',
                                    },
                                    {
                                        title: '增值税电子普通发票',
                                        key: 'e-normal',
                                    },
                                    {
                                        title: '增值税电子专用发票',
                                        key: 'e-special',
                                    }
                                ],
                                rules:[commonValidateRuleGo],
                            }}
                    />
                    },
                },
                {
                    text: '税率',
                    key:'tax_rate',
                    width: 100,
                    render:(_, target) => {
                        return <Select
                        required
                        v-model={target}
                        field = {{
                                key: 'tax_rate',
                             
                                items: [
                                    {
                                        title: '0%',
                                        key: 0,
                                    },
                                    {
                                        title: '1%',
                                        key: 0.01,
                                    },
                                    {
                                        title: '3%',
                                        key: 0.03,
                                    },
                                    {
                                        title: '6%',
                                        key: 0.06,
                                    },
                                    {
                                        title: '9%',
                                        key: 0.09,
                                    },
                                    {
                                        title: '13%',
                                        key: 0.13,
                                    },
                                    {
                                        title: '16%',
                                        key: 0.16,
                                    }
                                ],
                                rules:[commonValidateRuleGo],
                                
                            }}
                    />
                    },
               
                },
                {
                    text: '不含税金额',
                    key:'excluding_tax',
                    render:(_, target) => {
                        return <NumberField
                            v-model={target}
                            field = {{
                                key: 'excluding_tax',
                            }}
                        /> 
                    }
                },
                {
                    text: '税额',
                    render:(_, target) => {
                        let { contract_invoices = [] } = _this.params || {}
                        contract_invoices = contract_invoices || []
                        return <NumberField
                            v-model={target}
                            field = {{
                                key: 'tax',
                                'append-icon':  'mdi-calculator-variant',
                                'click:append': () => {
                                    if (contract_invoices.length > 1) {
                                        _this.$Message.error('多个发票行，无法自动计算，请手工填写~')
                                        return 
                                    }
                                    const contract_invoice = contract_invoices[0]
                                    const valid = [contract_invoice.tax_rate, _this.params.total_price].some(i => isIllegalityValue(i))
                                    if (!valid) {
                                        contract_invoice.excluding_tax = math.eval(`${_this.params.total_price}/(1+${contract_invoice.tax_rate})`).toFixed(2)
                                        contract_invoice.excluding_tax = Number(contract_invoice.excluding_tax)
                                        contract_invoice.tax = math.eval(`${_this.params.total_price}-${contract_invoice.excluding_tax}`).toFixed(2)
                                        contract_invoice.tax = Number(contract_invoice.tax)
                                    }
                                },
                            }}
                        /> 
                    }
                  },
                {
                    text: '操作',
                    align: 'center',
                    type: 'button_g_field',
                    // value: 'uid',
                     width: 120,
                     fixed: 'right',
                    render: (_, __, index) => {
                        if (_this.params.contract_invoices.length <= 1) {
                            return ''
                        }
                        return <VPopDel
                        title="确定删除该条数据？"
                        on={{
                            submit:() => {
                                _this.params.contract_invoices.splice(index, 1)
                            }
                        }}
                    />
                    }
                }
            ]
        },
        fields() {
            return [
                {
                    key:'table',
                    cols: 12,
                },
            ]
        }
    },
    render() {
        const _this = this
        return <div class={styles['block-margin']}>
        <VCard flat light outlined>
            <VCardTitle>
                发票信息
                <VBtn class={styles['btn-f']} 
                    outlined
                    color="primary"
                    small
                    on={{
                        click:() => {
                            const item = createContractInvoiceParams()
                            _this.params.contract_invoices.push(item)
                        }
                    }}
                    >
                    添加发票行
                </VBtn>
            </VCardTitle>
            <VCardText>
            <VForm
                ref="base"
                fields={_this.fields}
                scopedSlots={{
                    table:() => {
                        return <VTable
                            headers={this.table_fields}
                            desserts={this.params.contract_invoices}
                        />
                    }
                }}
            />
            </VCardText>
        </VCard>
    </div>
    }
}   